$(document).ready(function() {
  autowidth();
  var fbwidth = document.body.clientWidth;
  if (fbwidth > 840){
    var swiper = new Swiper(".mySwiper1", {
      slidesPerView: 2,
      spaceBetween: 30,
      slidesPerGroup: 1,
      pagination: { el: ".swiper-pagination", clickable: !0 },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  } else {
    var swiper = new Swiper(".mySwiper1", {
      slidesPerView: 1,
      spaceBetween: 30,
      slidesPerGroup: 1,
      loop: !0,
      pagination: { el: ".swiper-pagination", clickable: !0 },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  };
  var swiper = new Swiper(".mySwiper25", {
      effect: 'fade',
      slidesPerView: 1,
      spaceBetween: 30,
      slidesPerGroup: 1,
      loop: !0,
      pagination: { el: ".swiper-pagination", clickable: !0 },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  var swiper = new Swiper(".mySwiper26", {
      effect: 'fade',
      slidesPerView: 1,
      spaceBetween: 30,
      slidesPerGroup: 1,
      loop: !0,
      pagination: { el: ".swiper-pagination", clickable: !0 },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });

});



function autowidth() {
  var fullwidth = document.body.clientWidth;
  jQuery(".fullw").css({
    width: fullwidth,
    "margin-left": -fullwidth / 2,
    left: "50%",
  });
}
window.onresize = autowidth;


// 折叠文本，打开一个关闭其它
document.querySelectorAll("details").forEach((item) => {
  item.addEventListener("toggle", function () {
    if (this.open) {
      document.querySelectorAll("details").forEach((other) => {
        if (other !== this) other.removeAttribute("open");
      });
    }
  });
});